import { render, staticRenderFns } from "./ForumModalVideo.vue?vue&type=template&id=7b5f74ac"
import script from "./ForumModalVideo.vue?vue&type=script&lang=js"
export * from "./ForumModalVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports